import { render, staticRenderFns } from "./ProcessorBrowse.vue?vue&type=template&id=242c83e5&"
import script from "./ProcessorBrowse.vue?vue&type=script&lang=js&"
export * from "./ProcessorBrowse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProcessorBrowse.vue"
export default component.exports